import { gql } from '@apollo/client';

export const GetMillsForBids = gql`
  query NE_GetMillList {
    profile: profile {
      profile {
        acl {
          organisation_permissions {
            organisation_id
            bid_read
            bid_write
          }
        }
        organisations {
          id
          name
        }
      }
    }
}
`

export const GetMillList = gql`
  query NE_GetMillList {
    profile: profile {
      profile {
        organisations {
          id
          name
          type
          location {
            province
            district
            subdistrict
            village
          }
        }
      }
    }
}
`

// Every organisation on the caller's profile. Callers filter by `type` locally,
// so one query serves both the mill and conglomerate lists.
export const GetProfileOrganisations = gql`
  query NE_GetProfileOrganisations {
    profile: profile {
      profile {
        organisations {
          id
          name
          type
          deleted_at
          location {
            village
            district
            province
          }
        }
      }
    }
}
`

// Organisation profile plus its legal/tax block. The legal details do not live on
// the organisation itself -- they come from niaga_get_economics.
// Covers the rename and the reposition. The legal/tax block lives on its own
// mutation, UpdateLegalDetails.
export const UpdateOrganisationDetails = gql`
  mutation NE_UpdateOrganisationDetails($input: update_organisation_input!) {
    update_organisation(input: $input) {
      organisation {
        id
      }
    }
}
`

// Legal/tax block. Mirrors niaga_get_economics.legal_details on the read side,
// plus billing_address which the read still takes from the organisation itself.
export const UpdateLegalDetails = gql`
  mutation NE_UpdateLegalDetails($input: update_legal_details_input!) {
    update_legal_details(input: $input) {
      name
    }
}
`

export const GetOrganisationProfile = gql`
  query NE_GetOrganisationProfile($organisationId: Int!, $economics: niaga_get_economics_input!) {
    groups: niaga_groups_organisation_list_export(filter: {organisation_id: $organisationId}) {
      group_id
      organisation_id
      group_name
      is_public
    }

    org: organisation_profile(id: $organisationId) {
      organisation {
        id
        name
        type
        reputation_level
        billing_address
        apply_vat
        is_withholding_tax
        location {
          id
          village
          district
          subdistrict
          province
        }
      }
    }

    economics: niaga_get_economics(input: $economics) {
      buyer {
        niaga_at_mill_enabled
      }
      legal_details {
        name
        vat_number
        transaction_type
        address
        email
        phone_number
        postal_code
        rt
        rw
        location {
          id
          village
          district
          subdistrict
          province
        }
      }
    }
}
`

export const GetOrgDetail = gql`
  query NE_getOrgDetail($id: Int!, $input: niaga_get_economics_input!) {

    invites: ne_get_invitations(inviter_organisation_id: $id) {
        email
        firstname
        lastname
     }

    economics: niaga_get_economics(input: $input) {
      qbp {
        name
        cardinality
        delta
      }
      legal_details {
        name
        vat_number
        transaction_type
        address
        email
        phone_number
        postal_code
        rt
        rw
      }
    }

    va_list: ne_virtual_account_payment_codes(filter: {mill_id: $id}) {
        id
        provider_id
        va_number
        mill_id
        expire_at
        status
        reference_id
        amount
    }
    va_providers: available_payment_providers {
        id
        accepts_va
        bankCode
        displayName
        enabled
        legalName
    }

    org: organisation_detail(id: $id) {
      employees {
        organisation_permission {
          deactivated_at
          employee_write
          employee_read
          bid_read
          bid_write
        }
        person {
          id
          email
          first_name
          last_name
          transactor_id
          location {
            province
            district
            subdistrict
            village
          }
        }
     }
     organisation {
        id
        directions
        type
        location {
         district
         id
         province
         subdistrict
         village
        }
        name
        position {
         coordinates
         type
        }
     }
  }
}
`

// Only what the "Pay now" button needs (the mill's virtual accounts).
// GetOrgDetail stays for the company detail pages, which need the rest.
export const GetOrgPaymentMethods = gql`
  query NE_getOrgPaymentMethods($id: Int!) {
    va_list: ne_virtual_account_payment_codes(filter: {mill_id: $id}) {
        id
        provider_id
        va_number
        mill_id
        expire_at
        status
        reference_id
        amount
    }
    va_providers: available_payment_providers {
        id
        accepts_va
        bankCode
        displayName
        enabled
        legalName
    }
  }
`

export const UpdateEmployeePermissions = gql`
  mutation NE_UpdateEmployeePermissions($input: update_employee_permissions_input!) {
    update_employee_permissions(input: $input) {
      organisation {
        id
      }
    }
  }
`
export const generateVirtualAccount = gql`
  mutation ToolsGenerateVA($provider_id: String!, $mill_id: Int!, $amount: Int) {
    ne_create_virtual_account_payment_code(provider_id: $provider_id, mill_id: $mill_id, amount: $amount) {
      mill_id
      provider_id
      va_number
      status
      amount
    }
  }
`;